module.exports = __webpack_public_path__ + "static/media/fb-icon.9587f5f0.svg";